export type TimeFilter = "all" | "last10" | "thisMonth";

type MatchLike = {
  date?: Date | string;
  match_date?: Date | string;
};

function getMatchDate(match: MatchLike): Date {
  const raw = match.match_date ?? match.date;
  if (raw instanceof Date) return raw;
  return new Date(raw ?? 0);
}

export function filterMatchesByTime<T extends MatchLike>(
  matches: T[],
  filter: TimeFilter
): T[] {
  if (filter === "all") return matches;

  if (filter === "last10") {
    return [...matches]
      .sort((a, b) => getMatchDate(b).getTime() - getMatchDate(a).getTime())
      .slice(0, 10);
  }

  const now = new Date();
  return matches.filter((m) => {
    const d = getMatchDate(m);
    return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth();
  });
}
